import {useEffect, useState} from "react";

export function useDebounce(value: string, delay: number = 350): string {
  const [debouncedValue, setDebouncedValue] = useState(value.trim());

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value.trim()), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
